
import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import ExhibitionRelatedList from "./ExhibitionRelatedList"
import StandCategoryModal from "./StandCategoryModal"
import ExhibitionPricingModal from "./ExhibitionPricingModal"
// import ParticipationModal from "./ParticipationsModal"
import { ExhibitionStandCategory, ExhibitionPricing, Participation } from "./types"

const ExhibitionRelatedContainer: React.FC = () => {
  // Stand Category Modal State
  const [standCategoryModalOpen, setStandCategoryModalOpen] = useState(false)
  const [selectedStandCategory, setSelectedStandCategory] = useState<ExhibitionStandCategory | null>(null)

  // Pricing Modal State
  const [pricingModalOpen, setPricingModalOpen] = useState(false)
  const [selectedPricing, setSelectedPricing] = useState<ExhibitionPricing | null>(null)

  // Participation Modal State
  const [participationModalOpen, setParticipationModalOpen] = useState(false)
  const [selectedParticipation, setSelectedParticipation] = useState<Participation | null>(null)

  const [selectedExhibitionId, setSelectedExhibitionId] = useState<number>(0)

  const [refreshTrigger, setRefreshTrigger] = useState(false)

  // Stand Category Handlers
  const handleOpenAddStandCategory = () => {
    setSelectedStandCategory(null)
    setStandCategoryModalOpen(true)
  }

  const handleOpenEditStandCategory = (item: ExhibitionStandCategory) => {
    setSelectedStandCategory(item)
    setStandCategoryModalOpen(true)
  }

  const handleStandCategorySuccess = () => {
    setStandCategoryModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  // Pricing Handlers
  const handleOpenAddPricing = () => {
    setSelectedPricing(null)
    setPricingModalOpen(true)
  }

  const handleOpenEditPricing = (item: ExhibitionPricing) => {
    setSelectedPricing(item)
    setPricingModalOpen(true)
  }

  const handlePricingSuccess = () => {
    setPricingModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  // Participation Handlers
  const handleOpenAddParticipation = () => {
    setSelectedParticipation(null)
    setParticipationModalOpen(true)
  }

  const handleOpenEditParticipation = (item: Participation) => {
    setSelectedParticipation(item)
    setParticipationModalOpen(true)
  }

  const handleParticipationSuccess = () => {
    setParticipationModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Exhibition Details" parent="Exhibitions" />
      <Container fluid>
        <Row>
          <Col md="12">
           <ExhibitionRelatedList
              onAddStandCategory={handleOpenAddStandCategory}
              onEditStandCategory={handleOpenEditStandCategory}
              onAddPricing={handleOpenAddPricing}
              onEditPricing={handleOpenEditPricing}
              onAddParticipation={handleOpenAddParticipation}
              onEditParticipation={handleOpenEditParticipation}
              refreshTrigger={refreshTrigger}
              setExhibitionId={setSelectedExhibitionId}
            />
          </Col>
        </Row>

        {/* Stand Category Modal */}
        <StandCategoryModal
          isOpen={standCategoryModalOpen}
          toggle={() => setStandCategoryModalOpen(false)}
          onSuccess={handleStandCategorySuccess}
          initialData={selectedStandCategory}
          exhibitionId={selectedExhibitionId} // This will be set from ExhibitionRelatedList
        />

        {/* Pricing Modal */}
        <ExhibitionPricingModal
          isOpen={pricingModalOpen}
          toggle={() => setPricingModalOpen(false)}
          onSuccess={handlePricingSuccess}
          initialData={selectedPricing}
          exhibitionId={selectedExhibitionId} // This will be set from ExhibitionRelatedList
        />

        {/* Participation Modal */}
        {/* <ParticipationModal
          isOpen={participationModalOpen}
          toggle={() => setParticipationModalOpen(false)}
          onSuccess={handleParticipationSuccess}
          initialData={selectedParticipation}
          exhibitionId={0} // This will be set from ExhibitionRelatedList
        /> */}
      </Container>
    </>
  )
}

export default ExhibitionRelatedContainer
